<template>
  <AppDataGrid v-bind="$attrs" />
</template>

<script setup lang="ts"></script>

<style scoped></style>
